import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContractList } from '.';
import { api } from '../../services/api';
import { Contract } from '../../types/ContractType';
import { LoadingContext } from '../../providers/loading';
import { UserDataContext } from '../../providers/userData';
import { AuthContext } from '../../providers/auth';

export function ContractListContainer() {
  const navigate = useNavigate();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { userData } = useContext(UserDataContext);
  const { setState } = useContext(AuthContext);
  const [isEditContractModalOpen, setIsEditContractModalOpen] = useState(false);
  const [contractsData, setContractsData] = useState<Contract[]>([]);

  const [onEditContract, setOnEditContract] = useState<Contract>(Object);

  async function getContractsData() {
    setIsLoading({ value: true });

    await api.get('/contracts', {
      headers: {
        'Authorization': `Bearer ${userData.token}`
      }
    })
      .then(response => {
        if (response.data) {
          const contractsSorted = response?.data?.contracts.sort((a: Contract, b: Contract) => {
            if (a.number < b.number) {
              return -1;
            }
            if (a.number > b.number) {
              return 1;
            }
            return 0;
          });
          setContractsData(contractsSorted);
        }
      })
      .catch(error => {
        console.log(error);
        setState({ userIsLogged: false });
        localStorage.removeItem('user');
        navigate('/');
      });
    setIsLoading({ value: false });
  }

  function onEdit(contract: Contract) {
    setIsEditContractModalOpen(true);
    if (contract) {
      setOnEditContract(contract);
    }
  }

  async function onDelete(contractId: string) {
    setIsLoading({ value: true });
    if (contractId) {
      await api.delete(`/contracts?id=${contractId}`)
        .then(() => {
          getContractsData();
        })
        .catch(error => console.log(error));
    }
    setIsLoading({ value: false });
  }

  return (
    <ContractList
      isLoading={isLoading.value}
      contractsData={contractsData}
      onEditContractData={onEditContract}
      isEditContractModalOpen={isEditContractModalOpen}
      setIsEditContractModalOpen={setIsEditContractModalOpen}
      getContractsData={getContractsData}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
}
